/**
 * @license
 * Copyright (c) 2018 Crius Authors. All rights reserved.
 */

import '@polymer/polymer/polymer-element.js';

const $_documentContainer = document.createElement('template');
$_documentContainer.innerHTML = `
<dom-module id="cs-shared-styles-base-images">
	<template>
		<custom-style>
			<style>
        .h4:not([hidden])+img,
        .h6:not([hidden])+img {
            margin-top: 26px
        }

        @media only screen and (min-width:768px) {

            .h4:not([hidden])+img,
            .h6:not([hidden])+img {
                margin-top: 28px
            }
        }

        @media only screen and (min-width:1024px) {

            .h4:not([hidden])+img,
            .h6:not([hidden])+img {
                margin-top: 36px
            }
        }

        @media only screen and (min-width:1456px) {

            .h4:not([hidden])+img,
            .h6:not([hidden])+img {
                margin-top: 43px
            }
        }
        </style>
		</custom-style>
	</template>
</dom-module>`;

document.head.appendChild($_documentContainer.content);